// Onboarding module constants.
// Mirrors the shape used by other modules' constants.js (Const + Commons)
// so screens can build i18n keys via trans(`${langKey}.<key>`).

const key = "onboarding";
const baseRoute = "/onboarding";

export const Const = {
  onboarding: {
    lngKey: key,
    route: `${baseRoute}/start`,
  },
};

const cmn = "common";
export const Commons = {
  create: `${cmn}.create`,
  save: `${cmn}.save`,
  next: `${cmn}.next`,
  back: `${cmn}.back`,
  name: `${cmn}.name`,
  actions: `${cmn}.actions`,
};

// Ordered step definitions. `key` is used for wizard state + draft slices.
export const STEPS = [
  { key: "company", title: "Organisation" },
  { key: "employees", title: "Employees" },
  { key: "shifts", title: "Shifts & Attendance" },
  { key: "machines", title: "Attendance Devices" },
  { key: "leave", title: "Leave Setup" },
  { key: "loans", title: "Loans & Advances" },
  { key: "requestflow", title: "Approval Flows" },
  { key: "payrollpolicies", title: "Payroll Setup" },
  { key: "golive", title: "Review & Finish" },
];

export const DRAFT_KEY = "klok_onboarding_draft_v1";
